"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X = function X(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M9.227 7.813L5.684 4.27 4.27 5.684l3.543 3.543L4.27 12.77l1.414 1.414 3.543-3.543 3.543 3.543 1.414-1.414-3.543-3.543 3.543-3.543L12.77 4.27 9.227 7.813z" })
  );
};

exports.default = X;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/X.js
// module id = 700
// module chunks = 0